import { Component } from 'react';

export default class ScalableComponent extends Component {

	reScale(initialPixelValue) {
		return initialPixelValue * this.props.scale;
	}
}


// WEBPACK FOOTER //
// ./src/components/ScalableComponent.js